<template>
  <v-container>
    <v-layout>
    <v-flex>
      <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newType"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Tipo</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        fullscreen
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Tipo y Elementos</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="type.name"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm7 offset-sm1>
                  <v-text-field
                          name="description"
                          label="Descripción"
                          id="code"
                          v-model="type.description"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <h3 class="primary--text">Lista de Elementos</h3>
              <v-layout>
                <v-flex xs12 sm6 >
                  <div>
                    <v-btn :disabled="!valid" @click="newElement"  large color="primary">Nuevo elemento</v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <br/>

              <ul id="example-1">
                <li v-for="item in elements">
                  <td class="text-xs-left">
                    <v-text-field
                            name="nombre"
                            label="Nombre Elemento"
                            id="nombreElement"
                            :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                            v-model="item.name"
                            required
                    ></v-text-field>
                  </td>
                  <td class="text-xs-left">
                    <v-text-field
                            name="element"
                            label="Descripción"
                            id="descriptionElement"
                            v-model="item.description"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-tooltip top >
                      <v-btn fab dark small @click="deleteItemElement(item)" slot="activator" color="primary">
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </td>
                </li>
              </ul>

              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData" large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Tipos</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.types"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td>
            <v-tooltip top >
              <v-btn 
              fab dark 
              small @click="editItem(props.item)" 
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
import Type from '../../model/Type';
import Element from "../../model/Element";

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Descripción', value: 'description' },
        { text: 'Acciones', value: 'editar' },
      ],
      editedIndex: -1,
      type: new Type(),
      elements: [],
      element: new Element()
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.type = new Type();
      this.valid = false;
      this.dialog = false;
    },
    newType() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.type = new Type();
      this.elements=[]
    },
    saveData() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.type.elements=this.elements
          this.$store.dispatch('updateType', this.type).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        } else {
          this.type.elements=this.elements
          this.$store.dispatch('addType', this.type).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        }
        this.dialog = false;
      }
    },
    newElement(){
      if (this.$refs.form.validate()) {
        this.elements.push(new Element())
      }
    },
    editItem(item) {
      this.editedIndex = this.$store.state.types.indexOf(item);
      this.type = Object.assign({}, item);
      this.$store.dispatch("getElementsByType",this.type.id)
      this.elements=this.$store.state.elements
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.$store.state.types.indexOf(item);
      this.type = Object.assign({}, item);
      confirm('Está seguro de que quiere eliminar el registro?') &&
        this.$store.dispatch('deleteType', this.type.id);
    },
    deleteItemElement(item) {
      const index = this.elements.indexOf(item)
      if(confirm('Está seguro de que quiere eliminar el registro?')){

        this.element = Object.assign({}, item);
        if(this.element.id!=null && this.element!=''){
          this.$store.dispatch("deleteElement",this.element.id).then(
                  response => {
                    this.cleanData();
                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  }
          );
        }else{
          this.elements.splice(index, 1)
        }

      }
    }
  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getTypes').then(
      response => {
        this.cleanData();
      },
      error => {
        this.$store.state.dialogError = true;
      }
    );
  }
};
</script>

<style scoped>
  li{
    list-style:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/type/Type.vue